export const upcomingOccurrencesCount = (state = 0): number => state
